<script>
import Accordion from '../../../Accordion.vue'
import AccordionItem from '../../../AccordionItem.vue'

export default {
    components: {
        Accordion,
        AccordionItem,
    },

    props: {
        userDetail: {
            type: Object,
            required: true
        },
        module: {
            type: Object,
            required: true
        },
        traitStatementsByCluster: {
            type: Array,
            required: true
        },
    },

    methods: {
        isModuleAnswerChecked(answerId) {
            if (this.userDetail === null) {
                return false
            }

            return this.userDetail.user_module_answers.map(answer => answer.module_answers_id).includes(answerId)
        },
        isTraitRatingSelected(statementId, rating) {
            if (this.userDetail === null) {
                return false
            }

            return this.userDetail.user_detail_trait_statements.filter(statement => statementId == statement.trait_statement_id)
                .map(statement => statement.answer)
                .includes(rating)
        },
    },
}
</script>

<template>
    <div class="aims">
        <h3 class="mb-4">{{ module.title }}</h3>

        <div class="ml-4">
            <Accordion>
                <AccordionItem v-for="moduleSection in module.module_sections" :key="moduleSection.id">
                    <template slot="accordion-trigger">
                        <strong>{{ moduleSection.title }}</strong>
                    </template>

                    <template slot="accordion-content">
                        <div v-for="(moduleQuestion, i) in moduleSection.module_questions" class="mb-4">
                            <p v-html="moduleQuestion.question_text"></p>

                            <img v-if="moduleQuestion.question_picture" :src="`/img/${moduleQuestion.question_picture}`" alt="Question picture" />

                            <template v-for="answer in moduleQuestion.module_answers">
                                <input :disabled="true" type="radio" :id="`module-question-answer-${answer.id}`" :checked="isModuleAnswerChecked(answer.id)">

                                <label :for="`module-question-answer-${answer.id}`">
                                    {{ answer.value }}
                                </label>
                            </template>

                            <hr v-if="i < (moduleSection.module_questions.length - 1)">
                        </div>
                    </template>
                </AccordionItem>
            </Accordion>
        </div>

        <h3 class="mb-4">Questionnaire</h3>

        <div class="ml-4">
            <Accordion>
                <AccordionItem v-for="(traitStatements, cluster) in traitStatementsByCluster" :key="cluster">
                    <template slot="accordion-trigger">
                        <strong>Question set {{ cluster + 1 }} of {{ traitStatementsByCluster.length }}</strong>
                    </template>

                    <template slot="accordion-content">
                        <div v-for="traitStatement in traitStatements" class="mb-4">
                            <p v-html="traitStatement.text"></p>

                            <template v-for="rating in traitStatement.rating_maximum - traitStatement.rating_minimum">
                                <input :disabled="true" type="radio" :id="`trait-statement-${traitStatement.id}-${rating}`" :checked="isTraitRatingSelected(traitStatement.id, rating + traitStatement.rating_minimum)">

                                <label :for="`trait-statement-${traitStatement.id}-${rating}`">
                                    {{ rating + traitStatement.rating_minimum }}
                                </label>
                            </template>

                            <hr>
                        </div>
                    </template>
                </AccordionItem>
            </Accordion>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.aims {
    hr {
        max-width: unset;
    }

    img {
        max-width: 240px;
    }
}
</style>